import React from 'react'
import type { ComposeComponentImageFragment } from '../../../.graphql/generated-types'
import { PlainComposeComponentImage } from './plain'

export interface ContenfulImageProps {
  data: ComposeComponentImageFragment
}
export function ContentfulImage({ data }: ContenfulImageProps) {
  if (data.imageAsset?.height && data.imageAsset.width && data.imageAsset.url) {
    const { width, height } = data.imageAsset
    const minHeight = 320
    const maxHeight = 640
    let imageHeight = height
    let imageWidth = width
    const ratio = width / height
    if (imageHeight < minHeight) {
      imageHeight = minHeight
      imageWidth = imageHeight * ratio
    }
    if (imageHeight > maxHeight) {
      imageHeight = maxHeight
      imageWidth = imageHeight * ratio
    }

    return (
      <PlainComposeComponentImage
        data={data}
        width={imageWidth}
        height={imageHeight}
      />
    )
  }
  return <div></div>
}
